var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
      name: 'industrial_admin_order_details',
      query: {
        branchName: _vm.data.branchName,
        branchId: _vm.data.branchId,
        companyID: this.$route.query.companyID,
        startDate: this.$route.query.startDate,
        endDate: this.$route.query.endDate,
      },
    }}},[_c('button',[_vm._v(_vm._s(_vm.$t("text.clickButtons.viewDetails")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }